import { render, staticRenderFns } from "./EntityDetailLayout.vue?vue&type=template&id=01ac5c54&scoped=true"
import script from "./EntityDetailLayout.vue?vue&type=script&lang=js"
export * from "./EntityDetailLayout.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailLayout.vue?vue&type=style&index=0&id=01ac5c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac5c54",
  null
  
)

export default component.exports